<!-- Contextual bar -->
@if (config$ | async; as config) {
    <div class="contextual-bar-wrap flex align-items-center">
        <div class="contextual-bar flex-1 min-w-0 flex align-items-center">
            <!-- Back button -->
            <button
                class="circle-btn flex-shrink-0 w-3rem h-3rem border-round-md flex align-items-center justify-content-center cursor-pointer"
                (click)="goBack()"
                aria-label="Go back">
                <app-custom-icon
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-back-arrow-left'">
                </app-custom-icon>
            </button>

            <!-- Section switcher -->
            <button
                type="button"
                class="section-switcher flex-1 min-w-0 h-3rem gap-1 border-round-md flex align-items-center justify-content-between cursor-pointer"
                (click)="openSwitcher(config)"
                [attr.aria-label]="'Switch section, current: ' + config.currentLabel">
                <span
                    class="section-label white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    >{{ config.currentLabel }}</span
                >
                <app-custom-icon
                    class="flex-shrink-0"
                    [iconPath]="'assets/icons/general-icons.svg'"
                    [imageName]="'icon-chevron-up'">
                </app-custom-icon>
            </button>

            <!-- Add button (conditional) -->
            @if (config.showAdd) {
                <button
                    type="button"
                    class="circle-btn circle-btn--blue flex-shrink-0 w-3rem h-3rem border-round-md flex align-items-center justify-content-center cursor-pointer"
                    (click)="triggerAdd(config)"
                    aria-label="Add">
                    <app-custom-icon
                        [iconPath]="'assets/icons/general-icons.svg'"
                        [imageName]="'icon-add-new'">
                    </app-custom-icon>
                </button>
            }
        </div>
        <app-rise-agent-mobile-fab
            *featureFlag="'riseAgent'"></app-rise-agent-mobile-fab>
    </div>
}
